import 'vendors/promise-polyfill.js'
import 'vendors/zepto.js'
import 'vendors/iscroll.js'
import 'common/tongji.js'
import 'common/bottombar.js'

import 'ui/ui.less'

import VueLazyload from 'vue-lazyload'
import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import moment from 'moment'
import pnlogger from 'logger'
import cookie from 'cookie'
import ua from 'ua'
import user from 'user'
import { query } from 'qs'
import store from 'store2'
import { loginOut } from 'fetch'
import ChannelManager from 'ChannelManager'
import CityManager from 'cityManager'

const currentCity = CityManager.shared.getCurrentCity()




if (!process.server) {
  try {
    sessionStorage.setItem('city', JSON.stringify(currentCity))
    if (!cookie.get('cityId')) {
      cookie.set('cityId', currentCity.cityId, 24 * 365, '.piaoniu.com', '/')
    }
  } catch (e) {
    console.log(e)
  }
}


window.pnlogger = pnlogger
window.moment = moment
window.Vue = Vue
Vue.config.devtools = true
const sentryDisabled = window.sentryDisabled
if (process.browser) {
  if (query.debug || sessionStorage.getItem('debug')) {
    sessionStorage.setItem('debug', true)
    require('vconsole')
  }
}

if (query.bd_vid) {
  cookie.set('bd_vid', query.bd_vid)
  cookie.set('baiduUrl', location.href, 1)
}

if (process.browser) {
  const currentChannel = ChannelManager.current()
  if (currentChannel && currentChannel.stripBrand) {
    document.title = document.title.replace('-票牛网', '')
  }

  // 乐活暂没有纳入ChannelManager管理
  if (
    query.noAppLink ||
    (currentChannel && currentChannel.noAppLink) ||
    ua.isFromLehuo()
  ) {
    cookie.set('noAppLink', 1)
  }
}

// 配置错误监控
(function () {
  let environment = 'dev'
  let release = ''
  if (ua.isDev()) {
    environment = 'dev'
  } else if (ua.isBeta()) {
    environment = 'beta'
  } else if (ua.isProduct()) {
    environment = 'production'
    release = __BUILD__
  }

  // if (environment !== 'dev' && !sentryDisabled) {
  if (!['dev', 'beta', 'production'].includes(environment) && !sentryDisabled) {
    console.log('\x1b[32m%s\x1b[0m', '*****sentry*****');
    try {
      Sentry.init({
        dsn: 'https://fef8e8bb726445558cbf9fce4ceb60c4@sentry.piaoniu.com/2',
        // dsn: 'https://77260542fd504cdeb777fbc498afeef8@sentry.io/73542',
        environment,
        release,
        sampleRate: 1, // default is 1, can be set to something like 0.1
        integrations: [new Sentry.Integrations.Vue({ Vue })],
      })
      Sentry.configureScope((scope) => {
        let currentUser
        try {
          currentUser = store.get('user')
          currentUser = JSON.parse(currentUser)
        } catch (e) {
          console.log(e)
        }
        if (currentUser) {
          scope.setUser({
            name: currentUser.userName,
            email: currentUser.mobileNo,
          })
        }
      })
    } catch (e) {
      console.log(e)
    }
  }
})()

Vue.use(VueLazyload, {
  loading: require('common/img/loading.png'),
  preLoad: 0,
  listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove'],
  lazyComponent: true
})

Vue.use(ChannelManager) // 替换global的mixin方式，改为Plugin

if (
  location.pathname.includes('/campaign') &&
  !ua.isMobile() &&
  !location.pathname.includes('/pc.html') &&
  location.pathname.includes('index.html')
) {
  location.pathname = location.pathname.replace('/index.html', '/') + 'pc.html'
}

Vue.mixin({
  methods: {
    statisticsPageTD(key) {
      if (ua.isFromZhaohang()) {
        let statistics = require('zhaohangSdk').statisticsPageTD
        statistics(key)
      }
    },
    statisticsPage(key) {
      if (ua.isFromZhaohang()) {
        let statistics = require('zhaohangSdk').statisticsPage
        statistics(key)
      }
    },
  },
})

if (query.cmblife && !ua.isFromZhaohang()) {
  if (ua.isWechat()) {
    let cmbUrl = `cmblife://go?url=Web&version=v2&next=${encodeURIComponent(
      location.href
    )}`
    let jumpUrl = `https://a.app.qq.com/o/simple.jsp?pkgname=com.cmbchina.ccd.pluto.cmbActivity&android_scheme=${encodeURIComponent(
      cmbUrl
    )}&ios_scheme=${encodeURIComponent(cmbUrl)}`
    location.href = jumpUrl
  } else {
    const loadZHSDK = require('zhaohangSdk').loadZHSDK
    loadZHSDK()
      .then(() => {
        let cmbUrl = `cmblife://go?url=Web&version=v2&next=${encodeURIComponent(
          location.href
        )}`
        window.cmblife.executeProtocol(cmbUrl)
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

if (
  document.domain.indexOf('piaoniu') !== -1 &&
  document.domain.indexOf('qunar') === -1
) {
  document.domain = 'piaoniu.com'
}

if (
  query.noAppLink ||
  store.session.get('wesai') ||
  ua.isFromLehuo() ||
  ua.isFromZhaohang() ||
  ua.isFromNonghang()
) {
  cookie.set('noAppLink', 1)
}

if (query.confirmLogin) {
  cookie.set('confirmLogin', 1)
}
if (query.bd_vid) {
  cookie.set('baiduUrl', location.href, 1)
}
if (query.needLogin) {
  cookie.set('needLogin', 1)
}

if (ua.isPiaoniu() || ua.isPiaoniuMerchant()) {
  if (query.pner || query.pnid) {
    // loginOut(function(res) {
    const sensors = require('sensors')
    sensors.login(query.pnid)
    cookie.set('pner', query.pner, 24 * 365, '.piaoniu.com', '/')
    cookie.set('pnid', query.pnid, 24 * 365, '.piaoniu.com', '/')
    // })
  }
  if (query.cityId) {
    cookie.set('cityId', query.cityId)
  }
}

if (
  ua.isPiaoniuMiniProgram() ||
  ua.isAliMiniProgram() ||
  ua.isPiaoniuTiktokMiniProgram()
) {
  const pner = cookie.get('pner')
  if ((!query.pner || !query.pnid) && !pner) {
    loginOut(function (res) {
      const sensors = require('sensors')
      sensors.login(query.pnid)
      cookie.set('pner', query.pner, 24 * 365, '.piaoniu.com', '/')
      cookie.set('pnid', query.pnid, 24 * 365, '.piaoniu.com', '/')
    })
  }
  if (query.cityId) {
    cookie.set('cityId', query.cityId)
  }
  if (query.dvid) {
    cookie.set('dvid', query.dvid, 24 * 365, '.piaoniu.com', '/')
  }
}

// 适配招行
// 将由ChannelManager管理
if (ua.isFromZhaohang()) {
  document.addEventListener('DOMContentLoaded', () => {
    let $navBar = document.querySelector('.navbar')
    if ($navBar) {
      $navBar.style.display = 'none'
    }
  })
}

// 适配农行
// 将由ChannelManager管理
if (ua.isFromNonghang()) {
  const isIPhoneX =
    /iphone/gi.test(window.navigator.userAgent) &&
    window.devicePixelRatio &&
    window.devicePixelRatio === 3 &&
    window.screen.width === 375 &&
    window.screen.height === 812
  // iPhone XS Max
  const isIPhoneXSMax =
    /iphone/gi.test(window.navigator.userAgent) &&
    window.devicePixelRatio &&
    window.devicePixelRatio === 3 &&
    window.screen.width === 414 &&
    window.screen.height === 896
  // iPhone XR
  const isIPhoneXR =
    /iphone/gi.test(window.navigator.userAgent) &&
    window.devicePixelRatio &&
    window.devicePixelRatio === 2 &&
    window.screen.width === 414 &&
    window.screen.height === 896

  let topDistance = isIPhoneX || isIPhoneXSMax || isIPhoneXR ? 44 : 0
  if (ua.isIOS()) {
    document.addEventListener('DOMContentLoaded', () => {
      // document.body.style.paddingTop = topDistance + 'px'
      // let firstChild = document.body.firstChild
      // let emptyDiv = document.createElement('div')
      // 垃圾代码，后面去掉
      // emptyDiv.style.cssText = `position: fixed; top: 0; left: 0; right: 0;height:${topDistance}px; background: #fff;`
      // document.body.insertBefore(emptyDiv, firstChild)
      // setTimeout(() => {
      //   let $page = document.querySelector('.page')
      //   let $navBar = document.querySelector('.navbar')
      //   let $combineNavbar = document.querySelector('.combine-navbar')
      //   let $fixedWrap = document.querySelector('.fixed-wrap')
      //   let $fixedRow = document.querySelector(
      //     '.ticket-calendar__day-row--fixed'
      //   )
      //   // let $categoryHome = document.querySelector('.category-home')
      // 	// if ($categoryHome) {
      // 	// 	// $categoryHome.style.paddingTop = `${topDistance}px`
      // 	// 	let $cityList = document.querySelector('.city-list')
      // 	// 	// let $focusListHead = document.querySelector('.list-head')
      // 	// 	let $defaultSearch = document.querySelector('.default-search')
      // 	// 	let $suggestWrap = document.querySelector('.suggest-wrap')
      // 	// 	console.log($cityList,$defaultSearch,$suggestWrap)
      // 	// 	$cityList.style.top = `${topDistance}px`
      // 	// 	// $focusListHead.style.top = `${topDistance}px`
      // 	// 	$defaultSearch.style.top = `${topDistance + 44}px`
      // 	// 	$suggestWrap.style.top = `${topDistance + 44}px`
      // 	// }
      // 	if ($fixedWrap) {
      // 		$fixedRow.style.top = '146px'
      // 		$fixedWrap.style.top = '64px'
      // 	}
      // 	if ($combineNavbar) {
      // 		$combineNavbar.style.marginTop = topDistance + 'px'
      // 		return
      // 	}
      // 	if ($navBar && $page && !$page.classList.contains('no-fixed')) {
      // 		$navBar.style.marginTop = topDistance + 'px'
      // 		return
      // 	}
      // }, 500)
    })
  }
}

// 乐活登陆
user.leHuoLogin()

Vue.filter('cityName', function (name) {
  if (process.server) {
    return name
  } else {
    const currentChannel = ChannelManager.current()
    if (
      currentChannel &&
      currentChannel.name === '招行' &&
      ['台北', '澳门', '香港'].includes(name)
    ) {
      return '中国' + name
    }
    return name
  }
})
// 第三方接入mweb判断
if (query.isThirdWechatApp) {
  store.session.set('thirdChannel', query.isThirdWechatApp)
}



// WEBPACK FOOTER //
// ./src/common/common.js